import React from 'react';
import { ReactNode } from 'react';
import { Row } from 'react-table';
import { IBalanceInstruction } from '../../../../../../sp-types/balanceFlowType';
import { formatToShortString } from '../../../../../../utils/FormatValue';

const executedCellByColumnId = (id: string, data: IBalanceInstruction, defaultComponent: ReactNode) => {
  const {
    // action,
    // expectedPrice,
    // expiryDate,
    // instrumentId,
    // maximumPrice,
    // numberOfContracts,
    quantityPerContract,
    // status,
    executedNumberOfContracts,
    executedPrice,
  } = data;

  switch (id) {
    case 'lastPrice':
      return data.executedPrice ? formatToShortString(data.executedPrice) : 'Not Provided';
    case 'action':
      return (
        <div className="flex justify-between pe-[1rem]">
          <span>{data.action.charAt(0).toUpperCase() + data.action.slice(1)}</span>
          <img src="../assets/icons/colored/Approved_status.svg" />
        </div>
      );

    case 'maximumPrice':
      return '';

    case 'Instrument':
      return '';

    case 'Quantity':
      return executedPrice && executedNumberOfContracts
        ? formatToShortString(quantityPerContract * executedNumberOfContracts) // add unit from materialsMap
        : 0;

    case 'numberOfContracts':
      return data.executedNumberOfContracts || 'Not provided';

    case 'Total Price':
      return (
        '$' +
        (
          (data.executedNumberOfContracts ? data.executedNumberOfContracts : 1) *
          (data.quantityPerContract ? data.quantityPerContract : 1) *
          (data.executedPrice ? data.executedPrice : 1)
        ).toLocaleString()
      );

    case 'Expiry date':
      return '';

    default:
      return defaultComponent;
  }
};
interface ExecutedRowProps {
  row: Row<IBalanceInstruction>;
}

export const ExecutedRow: React.FC<ExecutedRowProps> = ({ row }) => {
  return (
    <tr>
      {row.cells.map((cell) => (
        <td
          key={cell.column.id}
          className="font-medium text-sm py-[0.5rem] ps-[1rem] border border-gray-200 bg-green-50"
        >
          {executedCellByColumnId(cell.column.id, row.original, cell.render('Cell'))}
        </td>
      ))}
    </tr>
  );
};
